import ApiService from '../../assets/js/api.service';
import {
    ACT_SET_EVENT_ATND_CHECK
    , ACT_GET_EVENT_ATND_CHECK_LIST
	, ACT_GET_DHFESTA_EVENT_MNG
} from '../_act_consts';

const state = {
}

const getters =  {
}

const mutations = {
}

const actions = {
  [ACT_SET_EVENT_ATND_CHECK]({}, params){
    return new Promise(resolve => {
      ApiService.post('/v1/app/dhfesta/event/atnd', params).then(response => resolve(response));
    });
  },
  [ACT_GET_EVENT_ATND_CHECK_LIST]({}, params){
    return new Promise(resolve => {
      ApiService.query('/v1/app/dhfesta/event/atnd/list', params).then(response => resolve(response));
    });
  },
  [ACT_GET_DHFESTA_EVENT_MNG]({}, params){
    return new Promise(resolve => {
      ApiService.query(`/v1/app/dhfesta/event/${params.campnId}/mng`, params).then(response => resolve(response));
    });
  },
}

export const event = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
